import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axiosInstance from '../api/axiosInstance';
import { useAuth } from '../hooks/useAuth';

const GoogleCallback: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { refetch } = useAuth();

  useEffect(() => {
    const code = searchParams.get('code');
    if (!code) {
      alert('인증 코드가 없습니다.');
      navigate('/login');
      return;
    }

    const processLogin = async () => {
      try {
        const res = await axiosInstance.get('/api/auth/google/callback', {
          params: { code }
        });

        if (res.data.success && res.data.token) {
          localStorage.setItem('token', res.data.token);
          await refetch();
          navigate('/');
        } else {
          throw new Error('인증 토큰을 받지 못했습니다.');
        }
      } catch (err: any) {
        console.error('구글 로그인 콜백 에러:', err);
        alert(err.response?.data?.error || '구글 로그인 처리에 실패했습니다.');
        navigate('/login');
      }
    };

    processLogin();
  }, [searchParams, navigate, refetch]);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '60vh' }}>
      <div className="loading-spinner" style={{ border: '4px solid rgba(0,0,0,0.1)', width: 36, height: 36, borderRadius: '50%', borderLeftColor: '#09f', animation: 'spin 1s linear infinite' }}></div>
      <p style={{ marginTop: 16, fontSize: 15, fontWeight: 500, color: '#666' }}>구글 계정으로 로그인 중입니다...</p>
      
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default GoogleCallback;
